import styled from '@emotion/styled'
import { Col, Card } from 'react-bootstrap'

export const SmallText = styled.div`
  label: TandCText;
  font-size: 13.5px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const TotalCommLabelStyled = styled(Col)`
  label: TotalCommLabelStyled;
  text-indent: 40%;
`
export const TotalCommSubLabelStyled = styled(Col)`
  label: TotalCommSubLabelStyled;
  text-indent: 30%;
`

export const RowEntryText = styled(Col)`
  label: RowEntryText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) =>
    props.boldText ? (props.theme.brand === 'Maxxia' ? 700 : 900) : 400};
`
export const RowEntryValue = styled(Col)`
  label: RowEntryValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: ${(props) => (props.right ? 'right' : 'left')};
  font-weight: ${(props) => (props.boldValue ? 900 : 400)};
`

export const StyledCard = styled(Card)`
  label: StyledCard;
  box-shadow: ${(props) =>
    props.pdf ? '' : 'rgba(0, 0, 0, 0.16) 0px 2px 16px'};
  border-color: ${(props) =>
    props.pdf ? props.theme.colors.primary : props.theme.colors.borderColor};
`
